module.exports = __webpack_public_path__ + "static/img_4-2ca4f7df49ac8d08d4fb586bab935fce.png";